import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

import { liveClassGetStudents } from '@school_ify/schoolify-repository/src/teacher/repositories/liveClassRepository';

export const getAllStudents = createAsyncThunk(
  'live_class/get_students',
  async (class_id: string) => {
    return liveClassGetStudents(class_id);
  }
);

const liveClassStudentsSlice = createSlice({
  name: 'live_class',
  initialState: {
    students: [],
    students_list: [],
    loading: '',
    error: '',
    selected: [],
  },
  reducers: {
    filter(state, search: PayloadAction<string>) {
      state.students_list = state.students.filter(obj => {
        return obj?.full_name?.toLocaleLowerCase().includes(search.payload.toLocaleLowerCase());
      });
    },
    resetStudentsList(state) {
      state.students = [];
    },
    selectStudent(state, id: PayloadAction<string>) {
      const index = state.selected.indexOf(id.payload);
      if (index > -1) {
        state.selected.splice(index, 1);
        return;
      }
      state.selected.push(id.payload);
    },
    selectedStudentsBaseSelection(state, payload: PayloadAction<string[]>) {
      state.selected = payload.payload;
    },
    unSelectStudents(state) {
      state.selected = [];
    },
    selectUnselectAllStudents(state) {
      if (state.selected.length === state.students.length) {
        state.selected = [];
        return;
      }

      state.selected = state.students.map(obj => {
        return obj.id;
      });
    },
  },
  extraReducers: builder => {
    builder.addCase(getAllStudents.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(getAllStudents.fulfilled, (state, action) => {
      state.loading = 'success';
      state.students = action.payload.student_class.map(obj => obj.user);
      state.students_list = action.payload.student_class.map(obj => obj.user);
    });
    builder.addCase(getAllStudents.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
  },
});

const selectState = state => state.liveClassStudentsSlice;
export const liveClassStudentsState = createSelector(selectState, items => {
  return {
    students: items.students_list,
    loading: items.loading,
    selectedStudents: items.selected,
  };
});

export const {
  selectStudent,
  filter,
  selectUnselectAllStudents,
  selectedStudentsBaseSelection,
  unSelectStudents,
  resetStudentsList,
} = liveClassStudentsSlice.actions;

export default liveClassStudentsSlice.reducer;
